const AttentionReply = () => import(/* webpackChunkName: 'wxnews' */ './attentionreply');
const KeyReply = () => import(/* webpackChunkName: 'wxnews' */ './keyreply');
const Create = () => import(/* webpackChunkName: 'wxnews' */ './create');
const PicWordMsg = () => import(/* webpackChunkName: 'wxnews' */ './picWordMsg');
const Qrcode = () => import(/* webpackChunkName: 'wxnews' */ './qrcode');
const ReplyRuleCreate = () => import(/* webpackChunkName: 'wxnews' */ './replyRuleCreate');
const Payment = () => import(/* webpackChunkName: 'wxnews' */ './payment');

const routes = [
  { path: '/wxnews/areply', component: AttentionReply, name: 'areply' },
  { path: '/wxnews/kreply', component: KeyReply },
  { path: '/wxnews/create', component: Create, name: 'create' },
  { path: '/wxnews/picWordMsg', component: PicWordMsg },
  { path: '/wxnews/qrcode', component: Qrcode },
  { path: '/wxnews/replyrule', component: ReplyRuleCreate, name: 'replyrule' },
  { path: '/wxnews/payment', component: Payment }
];

export default routes;
